import { setIn } from 'final-form';
import createDecorator from 'final-form-focus';
import React, { useCallback, useEffect, useState } from 'react';
import { Field, Form } from 'react-final-form';
import { connect, useDispatch } from 'react-redux';

import { setPage } from '@actions/page/page';
import { Button, createNotification } from '@components';
import { notificationStatuses } from '@constants';
import { StringInput } from '@form-components';
import { SiteLayout } from '@layouts';
import { composeValidators, emailValidator, required } from '@validators';

import '../login-page/login-page.scss';
import './forgot-password-page.scss';

const focusOnErrors = createDecorator();

const ForgotPasswordPage = () => {
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [resultMessage, setResultMessage] = useState();
    const dispatch = useDispatch();

    const onSubmit = useCallback(async values => {
        let response = await fetch('/api/site/auth/password/forgot', {
            method: 'POST',
            body: JSON.stringify(values),
            headers: { 'Content-Type': 'application/json' },
        });
        let { message } = await response.json();

        switch (response.status) {
            case 200:
                setResultMessage(message);
                setIsSubmitted(true);
                break;
            case 422:
                return setIn({}, 'email', 'Пользователь не найден');
            case 429:
                setResultMessage(message);

                return setIn({}, 'email', message);
            default:
                createNotification('Ошибка на сервере', notificationStatuses.error);
                break;
        }
    }, []);

    useEffect(() => {
        dispatch(setPage('/forgot-password'));
    }, [dispatch]);

    return <div>
        <div className='login__wrap'>
            <div className='login__container'>
                <section className='login'>
                    <div className='login__header'>
                        <h1 className='login__title'>Восстановление пароля</h1>
                    </div>

                    {!isSubmitted && <Form
                        onSubmit={onSubmit}
                        decorators={[focusOnErrors]}
                        render={({ handleSubmit, submitting }) =>
                            <form className='login__form' onSubmit={handleSubmit} noValidate={true}>
                                <div className='login__form-item login__form-input'>
                                    <Field
                                        name='email'
                                        component={StringInput}
                                        type='text'
                                        placeholder='E-mail'
                                        validate={composeValidators(required(), emailValidator())}
                                        required={true}
                                        secondary={true}
                                    />
                                </div>

                                <div className='login__form-item submit'>
                                    <Button
                                        className='forgot-password__log-in-btn'
                                        disabled={submitting}
                                    >
                                        Восстановить
                                    </Button>
                                </div>
                            </form>
                        }
                    />}

                    {isSubmitted && <div className='forgot-password__success-text'>
                        <h2 className='forgot-password__success-text__title'>{resultMessage}</h2>
                    </div>}
                </section>
            </div>
        </div>
    </div >;
};

ForgotPasswordPage.layout = {
    component: SiteLayout,
    isMinimalHeader: true,
};

export default connect(null)(ForgotPasswordPage);
